// 主题相关的工具函数
export const applyTheme = (theme) => {
  document.body.setAttribute('data-theme', theme);
  
  // 添加主题相关的 CSS 变量
  const root = document.documentElement;
  if (theme === 'dark') {
    root.style.setProperty('--bg-color', '#1a1a1a');
    root.style.setProperty('--text-color', '#e0e0e0');
    root.style.setProperty('--border-color', '#333');
    root.style.setProperty('--hover-color', '#2a2a2a');
  } else {
    root.style.setProperty('--bg-color', '#ffffff');
    root.style.setProperty('--text-color', '#333333');
    root.style.setProperty('--border-color', '#eee');
    root.style.setProperty('--hover-color', '#f0f4f8');
  }
};

export const toggleTheme = (currentTheme) => {
  const newTheme = currentTheme === 'dark' ? 'light' : 'dark';
  applyTheme(newTheme);
  return newTheme;
}; 